if (document.querySelector('#splideMainBigBanner') !== null) {
  const optionsMainBanner = {
    type: 'loop',
    fixedWidth: '100%',
    focus: 'center',
    gap: 0,
    pagination: false,
    arrowPath: 'M17.2417 10.5664L16.4561 11.3521L25.0986 19.9946L16.456 28.6372L17.2417 29.4229L26.6698 19.9948L26.6697 19.9946L26.6698 19.9945L17.2417 10.5664Z',
    autoplay: 'play',
    pauseOnHover: false,
    pauseOnFocus: false,
    mediaQuery: 'min',
    pagination: true,
    breakpoints: {
      1200: {
        fixedWidth: '1200px',
        gap: 18,
      },
    },
  };
  const splideMainBanner = new Splide('#splideMainBigBanner', optionsMainBanner);
  splideMainBanner.mount();
}
if (document.querySelector('#splideInformation') !== null) {
  const optionsInformation = {
    type: 'loop',
    autoWidth: true,
    focus: 'center',
    gap: 36,
    arrows: false,
    pagination: false,
    drag: 'free',
    flickPower: 100,
    autoScroll: {
      speed: 0.5,
      autoStart: true,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  };
  const splideInformation = new Splide('#splideInformation', optionsInformation);
  splideInformation.mount(window.splide.Extensions);
  const toggleButton = document.querySelector('#splideInformation .splide__toggle');
  if (splideInformation.Components.AutoScroll) {
    toggleButton.addEventListener('click', (e) => {
      if (splideInformation.Components.AutoScroll.isPaused()) {
        splideInformation.Components.AutoScroll.play();
      } else {
        splideInformation.Components.AutoScroll.pause();
      }
    });
  }
}
if (document.querySelector('.splide.list_menu') !== null) {
  const optionsMenuList = {
    autoWidth: true,
    perPage: 1,
    gap: 18,
    arrows: false,
    pagination: false,
    drag: 'free',
    flickPower: 100,
    mediaQuery: 'min',
    destroy: false,
    breakpoints: {
      768: {
        destroy: true,
      },
    },
  };
  const splideMenuLists = document.querySelectorAll('.list_menu');
  for (var i = 0; i < splideMenuLists.length; i++) {
    new Splide(splideMenuLists[i], optionsMenuList).mount();
  }
}
